export default class DimensionIdEnum {
  static get medicalCardStatus() {
    return "4828F876-76C4-49F7-A348-9F0E483A2368";
  }
  static get relation() {
    return "2A2174CA-46B4-ED11-8AB6-28C63FFA6990";
  }
  static get humanOrAnimal() {
    return "A0FB7CB7-8FE3-ED11-9F73-6045BD9258EA";
  }
  static get role() {
    return "6B2B0906-D33D-EE11-B8F0-6045BD92554D";
  }
  static get sex() {
    return "D40D28BE-8FE3-ED11-9F73-6045BD9258EA";
  }
  static get status() {
    return "4828F876-76C4-49F7-A348-9F0E483A2368";
  }
  static get biopsyStatus() {
    return "EAFCFEC5-13EC-EE11-AAB8-000C29E21A2A";
  }
  static get facility() {
    return "9AB1CDC1-76B0-EE11-AAB7-000C29E21A2A";
  }
  static get scanStatus() {
    return "349BC68D-3AA4-EF11-AAF6-000C29E21A2A";
  }
}
